import { render } from "./SessionRefreshCallback.vue?vue&type=template&id=5b8e879f&scoped=true"
import script from "./SessionRefreshCallback.vue?vue&type=script&lang=js"
export * from "./SessionRefreshCallback.vue?vue&type=script&lang=js"

import "./SessionRefreshCallback.vue?vue&type=style&index=0&id=5b8e879f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8e879f"]])

export default __exports__